import { Box } from "@mui/material";
import { useParams } from "react-router-dom";

import { useUserServicesPaginated } from "../../../GoService/api/queries/useUserServices";
import { useVisitServiceProfile } from "../../../GoService/api/queries/useVisitServiceProfile";

import ServiceProvided from "./components/ServiceProvided";
import MyServiceReviews from "./components/MyServiceReviews";
import MyOfferedServices from "./components/MyOfferedServices";

const SERVICE_LIMIT = 5;

const GoServiceTab = ({
  fullName,
  userId: entityUserId,
  isOwn,
  isDataProfileDataLoading,
}: {
  fullName: string;
  userId?: string;
  isOwn?: boolean;
  isDataProfileDataLoading?: boolean;
}) => {
  const { userId } = useParams();

  const ID = entityUserId || userId;

  const {
    data: servicesData,
    isLoading: isUserServicesLoading,
    isError: isUserServicesError,
  } = useUserServicesPaginated({
    userId: Number(ID),
    limit: SERVICE_LIMIT,
  });

  const IS_LOADING = isUserServicesLoading || Boolean(isDataProfileDataLoading);
  const IS_NO_SERVICES_PROVIDED = !IS_LOADING && !servicesData?.items.length;

  useVisitServiceProfile(Number(ID));

  return (
    <Box
      sx={{
        borderRadius: "8px",
        border: "1px solid #EAECF0",
        background: "var(--White, #FFF)",
        padding: "20px",
        display: "flex",
        flexDirection: "column",
        gap: "24px",
      }}
    >
      <ServiceProvided
        entityUserId={entityUserId}
        isOwn={isOwn}
        isDataProfileDataLoading={isDataProfileDataLoading}
        IS_NO_SERVICES_PROVIDED={IS_NO_SERVICES_PROVIDED}
      />
      <MyOfferedServices
        fullName={fullName}
        entityUserId={entityUserId}
        isOwn={isOwn}
        isDataLoading={IS_LOADING}
        servicesData={servicesData}
      />
      <MyServiceReviews
        fullName={fullName}
        entityUserId={entityUserId}
        isOwn={isOwn}
        isDataProfileDataLoading={IS_LOADING}
      />
    </Box>
  );
};

export default GoServiceTab;
